import Debug from '../helpers/debug.js';
import { baseApiBuilder } from '../helpers/baseBuilder.js';
import { etl } from './etl/index.js';
const debug = Debug('commands:etl');

const command = 'etl <action>';

const desc = 'Manage ETL scripts';

const builder = async function (yargs) {
  debug('builder', command);
  const base = await baseApiBuilder(yargs);
  return base.command(etl);
};

const handler = async function (argv) {
  debug('handler', command, argv);
};

export { command, desc, builder, handler };
